import BaseInfo from '../../../base/info';
import CustomDropdown from '../../../base/custom-dropdown';
import AppFileUpload from '../../../base/app-file-upload';

const OwnershipProof = () => {
  const handleFileChange = () => {
    // Handle file change logic here
    console.log('File changed');
  };

  const handleCurrencySelect = (value: any): void => {
    console.log('Selected currency:', value);
  };
  return (
    <div className="p-4 rounded-xl gap-8 flex flex-col border border-[#F1F2F4] w-full h-full bg-white ">
      <div className="grid gap-6">
        <p className="ryno_text_semibold">Proof of Ownership Verification</p>
        <BaseInfo
          type="information"
          text="Please provide either an identity number OR upload identity document images. Both options cannot be used simultaneously."
        />

        <div>
          <div>
            <CustomDropdown
              label={'Identity Document Type'}
              options={['USD', 'EUR'].map((currency) => ({
                name: currency,
                label: currency,
              }))}
              selectedValue={''}
              onSelectChange={handleCurrencySelect}
            />
          </div>

          <div className="grid grid-cols-2 gap-4">
            <AppFileUpload
              id="payment-receipt"
              type="file"
              label="Payment Receipt"
              onFileChange={handleFileChange}
              maxSize={4}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default OwnershipProof;
